import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the page content area to top on route changes.
 * Targets the #page-content container used by PageLayout.
 */
export default function useScrollToTop(): void {
  const { pathname } = useLocation();

  useEffect(() => {
    const el = document.getElementById('page-content');
    if (el) {
      el.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [pathname]);
}
